<script>
  import ApplicationState from "../../../../Stores/applicationStates"
  import ShareComponent from "../../../../Shared/shareComponent.svelte"
  import { loadQR } from "../../../Publish/BulkUpload/Script/bulkUpload"
  import { onMount, afterUpdate } from "svelte"
  export let url
  /**
   * @type {String} - qr code url
   */
  let qrURL

  afterUpdate(async () => {
    if (url.url != undefined) qrURL = await loadQR(`${$ApplicationState?.viewBase?.replace("/v2/", `/v${url.version}/`) + url.url}`)
  })
</script>

<div class="rounded-md">
  <!-- <div class="flex items-center gap-1 mobile:gap-3">
    <button type="button" class="flex cursor-pointer items-center justify-center gap-1.5 rounded-full bg-blue-500 px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
      <i class="fa-solid fa-circle-check hidden sm:block" />
      Valid
    </button>
    <button type="button" class="flex cursor-pointer items-center justify-center gap-1.5 rounded-full bg-gray-100/50 px-3 py-1 text-xs text-white focus-visible:text-white focus-visible:outline-none md:px-3 lg:py-1.5 xl:gap-3 xl:px-6">
      <i class="fa-solid fa-envelope hidden sm:block" />
      Email
    </button>
  </div> -->
  <div class="flex flex-col items-center justify-between gap-3 sm:flex-row">
    <div class="order-2 flex w-full flex-col items-center gap-3 sm:order-1 sm:items-start md:w-4/6">
      <div class="pt-3">
        <a class="flex break-all text-center text-blue-500 underline hover:text-blue-600 active:text-blue-400 sm:text-start" target="_blank" href={$ApplicationState?.viewBase?.replace("/v2/", `/v${url.version}/`) + url.url}>{$ApplicationState?.viewBase?.replace("/v2/", `/v${url.version}/`) + url.url}</a>
        <p class="select-none text-center text-gray-200 sm:text-start">Click URL to open in new tab</p>
      </div>
      <!-- share -->
      <ShareComponent Link={$ApplicationState?.viewBase?.replace("/v2/", `/v${url.version}/`) + url.url} />
    </div>
    <div class="order-1 flex w-full select-none flex-col items-center gap-3 sm:order-2 md:w-2/6">
      <img src={qrURL} class="w-1/3 rounded-md sm:w-4/6" alt="qrcode" />
      <!-- border-2 border-[#a0a1a580]  -->
    </div>
  </div>
</div>
